import { render } from "./HowToGuides.vue?vue&type=template&id=8b0407b8&scoped=true"
import script from "./HowToGuides.vue?vue&type=script&lang=js"
export * from "./HowToGuides.vue?vue&type=script&lang=js"

import "./HowToGuides.vue?vue&type=style&index=0&id=8b0407b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b0407b8"]])

export default __exports__